<template>
  <VCard
    variant="flat"
    border
    :style="cardStyle"
    class="border-thin"
    data-testid="base-card"
  >
    <template #title>
      <div
        class="base-card__title-container noselect py-4"
        data-testid="card-title-container"
      >
        <div v-if="icon" class="header-icon" data-testid="card-header-icon">
          <VIcon color="primary" size="20">
            {{ icon }}
          </VIcon>
        </div>
        <slot name="header-title"> Default Title </slot>
      </div>
      <slot name="header-right" />
    </template>

    <VDivider v-if="header" data-testid="card-header-divider" />

    <VCardActions
      v-if="hasSlot('subheader')"
      class="base-card__subheader pa-0"
      data-testid="card-subheader"
    >
      <slot name="subheader" />
    </VCardActions>

    <VDivider
      v-if="hasSlot('subheader')"
      data-testid="card-subheader-divider"
    />

    <div
      v-if="hasSlot('content')"
      class="base-card__content"
      :style="{
        'min-height': minHeight,
        height: contentHeight,
        padding: padding,
      }"
      data-testid="card-content"
    >
      <slot name="content"> Default Content </slot>
    </div>

    <div v-if="hasSlot('mock')" class="base-card__mock" data-testid="card-mock">
      <slot name="mock" />
    </div>

    <div
      v-if="hasSlot('footer')"
      class="base-card__footer"
      data-testid="card-footer"
    >
      <slot name="footer" />
    </div>

    <div
      v-if="hasSlot('footer-pagination')"
      class="base-card__footer"
      data-testid="card-footer-pagination"
    >
      <div class="pagination">
        <slot name="footer-pagination" />
      </div>
    </div>
  </VCard>
</template>

<script setup>
  import { computed, useSlots } from "vue";

  const props = defineProps({
    icon: {
      type: String,
      default: "",
    },
    itemMaxHeight: {
      type: String,
      default: "",
    },
    useVuetifyIcon: {
      type: Boolean,
      default: false,
    },
    minHeight: {
      type: String,
      default: null,
    },
    padding: {
      type: String,
      default: "12px",
    },
    header: {
      type: Boolean,
      default: true,
    },
    fillHeight: {
      type: Boolean,
      default: false,
    },
    minHeightSubHeader: {
      type: String,
      default: "40px",
    },
  });

  const slots = useSlots();

  const hasSlot = (name) => !!slots[name];

  const cardStyle = computed(() => ({
    "max-height": props.itemMaxHeight,
    height: props.fillHeight ? "100%" : null,
  }));

  const contentHeight = computed(() => {
    const headerSize = 64;
    const heightSubheader = parseInt(props.minHeightSubHeader.slice(0, -2));
    if (!props.fillHeight) {
      return props.minHeight;
    }
    if (hasSlot("subheader") && props.header) {
      return `calc(100% - ${headerSize + heightSubheader}px)`;
    }
    if (props.header) {
      return `calc(100% - ${headerSize}px)`;
    }
    if (hasSlot("subheader")) {
      return `calc(100% - ${heightSubheader}px)`;
    }
    return "100%";
  });
</script>

<style lang="scss">
  .base-card__title-container {
    padding: 0.75rem;
    color: #00669e;
    flex: 1 auto;
    line-height: 1rem;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    font-weight: normal;

    .header-icon {
      margin-right: 1rem;
    }
  }

  .base-card__content {
    overflow-y: auto;
    padding: 1rem;
    align-items: center;

    .base-button-empty__container .btn {
      width: 121px;
      height: 33px;
      border-radius: 7px;
    }
  }

  .base-card__mock {
    padding: 0;
    align-items: center;

    .base-button-empty__container .btn {
      width: 121px;
      height: 33px;
      border-radius: 7px;
    }
  }

  .base-card__footer {
    margin-bottom: 10px;
  }
</style>
